import { listen } from '../../common/frame-event';

const Height = (callback) => {
    listen('DOCUMENT-HEIGHT', function (e) {
        callback && callback(e.data);
    });
};


export default Height ;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/iframe.js